import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { GET_BULK_ORDER_BY_ID } from 'Store/OrderManagement/BulkOrderById/BulkOrderByIdType';
import OrderManagementApiService from 'Service/OrderManagement/OrderManagementApiService';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setBulkOrderById } from 'Store/OrderManagement/BulkOrderById/BulkOrderByIdAction';

function* getBulkOrderByIdSaga(orderRequest: any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.OrderManagement,
            endpoint: `orders/getbulkorderdetail/${orderRequest?.payload?.orderId}/${orderRequest?.payload?.isEdit}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData

        );

        if (response) {
            yield put(setBulkOrderById(response));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setBulkOrderById(null));
    }
}

function* watchBulkOrderById() {
    yield takeEvery(GET_BULK_ORDER_BY_ID, getBulkOrderByIdSaga)
}

export default function* combinedSaga() {
    yield all([
        watchBulkOrderById()
    ])
}
